export const convert64 = (event) => {
    return new Promise((resolve, reject) => {
        const file = event.target.files[0];

        console.log("Event: ", event, file);

        if (file) {
            // Verificar formato del archivo
            const allowedFormats = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
            if (!allowedFormats.includes(file.type)) {
                alert("Por favor, selecciona una imagen en formato PNG, JPG, JPEG o WEBP.");
                //reject("Formato de archivo no permitido");
                return false;
            } 

            const reader = new FileReader();
            reader.onload = function (e) {
                const base64String = e.target.result;
                console.log("64: ", base64String);
                resolve(base64String);
            };
            reader.onerror = function (error) {
                reject("Error al leer el archivo: " + error);
            };
            reader.readAsDataURL(file);
        } else {
            console.log("No hay archivo");
            reject("No se seleccionó ningún archivo");
        }
    });
};
